import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { ACCOUNT_API_COMPANIES } from 'apiRoutes';
import { companyTableColumns } from './companyTableColumns';
import { Table } from 'components/tables/Table';
import { useNavigate } from 'react-router';
import { Company } from 'domain/company/Company';
import { Button } from '@montel/montelpro-shared-components-v2';
import { CreateCompanyModal } from './CreateCompanyModal';
import { useGet } from 'hooks/useGet';
import { AdminRole } from 'domain/account/enums/AdminRole';
import { AccessControl } from 'components/common/AccessControl/AccessControl';

interface CompanyTableProps {}

const CompanyTable: FunctionComponent<CompanyTableProps> = ({}) => {
	const { getData, data, status } = useGet(
		`${ACCOUNT_API_COMPANIES}/GetCompanies`,
	);

	const [companies, setCompanies] = useState<Company[]>([]);
	const [showCreateCompanyModal, setShowCreateCompanyModal] = useState(false);

	const columns = useMemo(() => {
		const columns = [
			companyTableColumns.name(),
			companyTableColumns.created(),
			companyTableColumns.country(),
			companyTableColumns.youniumAccountNumber(),
			companyTableColumns.isCustomer(),
		];

		return columns;
	}, []);

	useEffect(() => {
		getData();
	}, []);

	useEffect(() => {
		if (data) {
			setCompanies(data);
		}
	}, [data]);

	const navigate = useNavigate();

	const onCompanyCreated = () => {
		getData();
		setShowCreateCompanyModal(false);
	};

	return (
		<>
			<Table<Company>
				columns={columns}
				requestStatus={status}
				data={companies}
				withPagination
				withSearch
				showRowCount
				initialSorting={[
					{
						id: 'created',
						desc: true,
					},
				]}
				onRowClicked={(row) => navigate(`/companies/${row.id}`)}
			/>
			<AccessControl
				allowedRoles={[
					AdminRole.SUPER_ADMIN,
					AdminRole.MONTEL_ACCOUNT_ADMIN,
				]}
			>
				<Button
					variant="primary"
					onClick={() => setShowCreateCompanyModal(true)}
					text={'Create Company'}
				/>
				<CreateCompanyModal
					showModal={showCreateCompanyModal}
					setShowModal={setShowCreateCompanyModal}
					onCompanyCreated={onCompanyCreated}
				/>
			</AccessControl>
		</>
	);
};

export default CompanyTable;
